module.exports = __webpack_public_path__ + "img/header-bg.3753c6f1.png";